import React, { useEffect, useReducer } from 'react'
import {
  countToStr,
  getSupplierId,
  isResponseCodeSuccess,
} from '../../../tools/util'
import {
  GET_RETURNORDER_PAGE,
  GET_ORDERRETURN_STATECOUNT,
  ReturnManagementParam,
} from '../../../api/orderManage'
import { message } from 'antd'
import { useSkipInitEffect } from '../../../tools/utilHooks'

export type returnManagementTabKey =
  | '退货申请'
  | '取消申请'
  | '退货中'
  | '已完成'
  | '全部'
type RadioDict = {
  [x in returnManagementTabKey]: {
    key: string
    keyName: string
    value: string
    numMap: string
  }
}
interface paginationOption {
  total: number
  current: number
  pagesize: number
}
interface orderCountsState {
  applyCount: number // 退货中订单个数
  cancelCount: number // 取消申请订单个数
  processCount: number // 退货中个数
}

interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: returnManagementTabKey // 当前选中tab的key值
  dateSource: any[]
  isTableLoading?: boolean
  orderCountsState: orderCountsState
  pagination: paginationOption
  searchParam: any
}
type ActionType =
  | 'setCurrentRadioDict'
  | 'setCheckedRadioKey'
  | 'setPagination'
  | 'setOrderCountsState'
  | 'setDataSource'
  | 'setIsTableLoading'
  | 'setSearchParam'
interface Action {
  type: ActionType
  payload: any
}

const initialRadioDict: RadioDict = {
  退货申请: {
    key: 'returnApply',
    value: '退货申请(0)',
    keyName: '退货申请',
    numMap: '1',
  },
  取消申请: {
    key: 'cancelApply',
    value: '取消申请(0)',
    keyName: '取消申请',
    numMap: '1',
  },
  退货中: {
    key: 'returnning',
    value: '退货中(0)',
    keyName: '退货中',
    numMap: '2',
  },
  已完成: {
    key: 'finished',
    value: '已完成',
    keyName: '已完成',
    numMap: '3',
  },
  全部: {
    key: 'all',
    value: '全部',
    keyName: '全部',
    numMap: '0',
  },
}
const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '退货申请',
  dateSource: [],
  isTableLoading: false,
  orderCountsState: {
    applyCount: 0,
    cancelCount: 0,
    processCount: 0,
  },
  pagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setOrderCountsState':
      newstate.orderCountsState = action.payload
      return newstate
    case 'setCurrentRadioDict':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setDataSource':
      newstate.dateSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}
/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})
/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
const setCurrentRadioDict = (val: any): Action => ({
  type: 'setCurrentRadioDict',
  payload: val,
})
/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
const setCheckedRadioKey = (val: React.Key): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})
/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
const setDataSource = (val: paginationOption): Action => ({
  type: 'setDataSource',
  payload: val,
})
/**
 * 设置订单数据相关
 * @param val
 * @returns
 */
const setOrderCountsState = (val: orderCountsState): Action => ({
  type: 'setOrderCountsState',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})
export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    checkedRadioKey,
    currentRadioDict,
    dateSource,
    isTableLoading,
    orderCountsState,
    pagination,
    searchParam,
  } = state
  const handleCheckedChange = (key: any) => {
    dispatch(setCheckedRadioKey(key))
  }
  const handleSearchClick = (value: any) => {
    dispatch(setSearchParam(value))
  }

  function handlePaginationChange(page: number, pageSize?: number) {
    dispatch(
      setPagination({
        ...pagination,
        pagesize: pageSize ? pageSize : pagination.pagesize,
        current: page,
      }),
    )
  }

  const getOrderCountsState = async () => {
    const res = await GET_ORDERRETURN_STATECOUNT({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setOrderCountsState({ ...res.data }))
    } else {
      message.warning(res.msg)
    }
  }
  const handleOrderListRequest = async (param: ReturnManagementParam) => {
    const { pageNo, pageSize } = param
    dispatch(setIsTableLoading(true))
    const res = await GET_RETURNORDER_PAGE({
      ...param,
      ...searchParam,
      returnState: undefined,
    })
    if (isResponseCodeSuccess(res.code)) {
      // 设置当前表格数据
      dispatch(setDataSource(res.data.content))
      // 设置当前页面数据量
      dispatch(
        setPagination({
          ...pagination,
          pagesize: pageSize ? pageSize : pagination.pagesize,
          current: pageNo ? pageNo : pagination.current,
          total: res.data.totalCount,
        }),
      )
      dispatch(setIsTableLoading(false))
    } else {
      message.warning(res.msg)
    }
  }
  const handleTableRefresh = async () => {
    if (pagination.current === 1) {
      handleOrderListRequest({
        pageNo: 1,
        pageSize: pagination.pagesize,
      })
    } else {
      dispatch(
        setPagination({
          ...pagination,
          current: 1,
        }),
      )
    }
  }

  useSkipInitEffect(() => {
    handleTableRefresh()
  }, [searchParam])

  // 首次加载页面时，获取订单数量
  useEffect(() => {
    getOrderCountsState()
  }, [])

  useEffect(() => {
    handleOrderListRequest({
      pageSize: pagination.pagesize,
      pageNo: pagination.current,
    })
    // eslint-disable-next-line
  }, [pagination.current, pagination.pagesize, checkedRadioKey])

  // orderCountsState 发生变化的时候，带动tab数据变化。
  useEffect(() => {
    const newRadioDict = { ...currentRadioDict }
    newRadioDict['退货申请'].value = `退货申请(${countToStr(
      orderCountsState.applyCount,
    )})`
    newRadioDict['取消申请'].value = `取消申请(${countToStr(
      orderCountsState.cancelCount,
    )})`
    newRadioDict['退货中'].value = `退货中(${countToStr(
      orderCountsState.processCount,
    )})`
    dispatch(setCurrentRadioDict(newRadioDict))
    // eslint-disable-next-line
  }, [orderCountsState])

  return {
    checkedRadioKey,
    currentRadioDict,
    dateSource,
    isTableLoading,
    pagination,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
  }
}
import React, { useEffect, useReducer } from 'react'
import {
  countToStr,
  getSupplierId,
  isResponseCodeSuccess,
} from '../../../tools/util'
import {
  GET_RETURNORDER_PAGE,
  GET_ORDERRETURN_STATECOUNT,
  ReturnManagementParam,
} from '../../../api/orderManage'
import { message } from 'antd'
import { useSkipInitEffect } from '../../../tools/utilHooks'

export type returnManagementTabKey =
  | '退货申请'
  | '取消申请'
  | '退货中'
  | '已完成'
  | '全部'
type RadioDict = {
  [x in returnManagementTabKey]: {
    key: string
    keyName: string
    value: string
    numMap: string
  }
}
interface paginationOption {
  total: number
  current: number
  pagesize: number
}
interface orderCountsState {
  applyCount: number // 退货中订单个数
  cancelCount: number // 取消申请订单个数
  processCount: number // 退货中个数
}

interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: returnManagementTabKey // 当前选中tab的key值
  dateSource: any[]
  isTableLoading?: boolean
  orderCountsState: orderCountsState
  pagination: paginationOption
  searchParam: any
}
type ActionType =
  | 'setCurrentRadioDict'
  | 'setCheckedRadioKey'
  | 'setPagination'
  | 'setOrderCountsState'
  | 'setDataSource'
  | 'setIsTableLoading'
  | 'setSearchParam'
interface Action {
  type: ActionType
  payload: any
}

const initialRadioDict: RadioDict = {
  退货申请: {
    key: 'returnApply',
    value: '退货申请(0)',
    keyName: '退货申请',
    numMap: '1',
  },
  取消申请: {
    key: 'cancelApply',
    value: '取消申请(0)',
    keyName: '取消申请',
    numMap: '1',
  },
  退货中: {
    key: 'returnning',
    value: '退货中(0)',
    keyName: '退货中',
    numMap: '2',
  },
  已完成: {
    key: 'finished',
    value: '已完成',
    keyName: '已完成',
    numMap: '3',
  },
  全部: {
    key: 'all',
    value: '全部',
    keyName: '全部',
    numMap: '0',
  },
}
const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '退货申请',
  dateSource: [],
  isTableLoading: false,
  orderCountsState: {
    applyCount: 0,
    cancelCount: 0,
    processCount: 0,
  },
  pagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setOrderCountsState':
      newstate.orderCountsState = action.payload
      return newstate
    case 'setCurrentRadioDict':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setDataSource':
      newstate.dateSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}
/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})
/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
const setCurrentRadioDict = (val: any): Action => ({
  type: 'setCurrentRadioDict',
  payload: val,
})
/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
const setCheckedRadioKey = (val: React.Key): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})
/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
const setDataSource = (val: paginationOption): Action => ({
  type: 'setDataSource',
  payload: val,
})
/**
 * 设置订单数据相关
 * @param val
 * @returns
 */
const setOrderCountsState = (val: orderCountsState): Action => ({
  type: 'setOrderCountsState',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})
export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    checkedRadioKey,
    currentRadioDict,
    dateSource,
    isTableLoading,
    orderCountsState,
    pagination,
    searchParam,
  } = state
  const handleCheckedChange = (key: any) => {
    dispatch(setCheckedRadioKey(key))
  }
  const handleSearchClick = (value: any) => {
    dispatch(setSearchParam(value))
  }

  function handlePaginationChange(page: number, pageSize?: number) {
    dispatch(
      setPagination({
        ...pagination,
        pagesize: pageSize ? pageSize : pagination.pagesize,
        current: page,
      }),
    )
  }

  const getOrderCountsState = async () => {
    const res = await GET_ORDERRETURN_STATECOUNT({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setOrderCountsState({ ...res.data }))
    } else {
      message.warning(res.msg)
    }
  }
  const handleOrderListRequest = async (param: ReturnManagementParam) => {
    const { pageNo, pageSize } = param
    dispatch(setIsTableLoading(true))
    const res = await GET_RETURNORDER_PAGE({
      ...param,
      ...searchParam,
      returnState: undefined,
    })
    if (isResponseCodeSuccess(res.code)) {
      // 设置当前表格数据
      dispatch(setDataSource(res.data.content))
      // 设置当前页面数据量
      dispatch(
        setPagination({
          ...pagination,
          pagesize: pageSize ? pageSize : pagination.pagesize,
          current: pageNo ? pageNo : pagination.current,
          total: res.data.totalCount,
        }),
      )
      dispatch(setIsTableLoading(false))
    } else {
      message.warning(res.msg)
    }
  }
  const handleTableRefresh = async () => {
    if (pagination.current === 1) {
      handleOrderListRequest({
        pageNo: 1,
        pageSize: pagination.pagesize,
      })
    } else {
      dispatch(
        setPagination({
          ...pagination,
          current: 1,
        }),
      )
    }
  }

  useSkipInitEffect(() => {
    handleTableRefresh()
  }, [searchParam])

  // 首次加载页面时，获取订单数量
  useEffect(() => {
    getOrderCountsState()
  }, [])

  useEffect(() => {
    handleOrderListRequest({
      pageSize: pagination.pagesize,
      pageNo: pagination.current,
    })
    // eslint-disable-next-line
  }, [pagination.current, pagination.pagesize, checkedRadioKey])

  // orderCountsState 发生变化的时候，带动tab数据变化。
  useEffect(() => {
    const newRadioDict = { ...currentRadioDict }
    newRadioDict['退货申请'].value = `退货申请(${countToStr(
      orderCountsState.applyCount,
    )})`
    newRadioDict['取消申请'].value = `取消申请(${countToStr(
      orderCountsState.cancelCount,
    )})`
    newRadioDict['退货中'].value = `退货中(${countToStr(
      orderCountsState.processCount,
    )})`
    dispatch(setCurrentRadioDict(newRadioDict))
    // eslint-disable-next-line
  }, [orderCountsState])

  return {
    checkedRadioKey,
    currentRadioDict,
    dateSource,
    isTableLoading,
    pagination,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
  }
}
